import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../../../../../helpers/export'
import ScoreCompanyService from '../../../../../../core/service'

export const getLinkageScore = createAsyncThunk(
  'companyAnalysis/scoreCompany/CorporateLinkageScore/getLinkageScore',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getLinkageScore(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

//download
export const downloadLinkageScore = createAsyncThunk(
  'companyAnalysis/scoreCompany/CorporateLinkageScore/export',
  async (params, { rejectWithValue }) => {
    const response = await ScoreCompanyService.downloadLinkageScore(params)
    handleExport(response.data, response.filename)
  },
)
